<template>
  <div class="space-y-2">
    <textarea
      v-select
      v-model="syncContent"
      rows="5"
      class="px-4 py-2 leading-5 text-sm border rounded hover:border-gray-700 focus:outline-none focus:border-gray-700 focus:ring ring-blue-500 ring-opacity-50 w-full resize-none"
    />
    <div class="space-x-2">
      <button
        type="button"
        class="px-4 py-2 leading-4 text-xs rounded bg-green-600 border border-transparent text-white hover:bg-green-500 focus:border-green-700 focus:outline-none focus:ring ring-green-500 ring-opacity-50 disabled:bg-gray-600"
        :disabled="!syncContent"
        @click="update"
      >
        Update
      </button>
      <button
        type="button"
        class="px-4 py-2 leading-4 text-xs rounded bg-transparent border border-transparent text-gray-700 hover:bg-gray-300 hover:text-gray-900 focus:border-gray-500 focus:outline-none focus:bg-gray-300"
        @click="cancel"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoteEditor',

  props: {
    content: {
      type: String,
      default: '',
    },
  },

  methods: {
    update() {
      if (!this.content) {
        return;
      }

      this.$emit('update');
    },

    cancel() {
      this.$emit('cancel');
    },
  },

  computed: {
    syncContent: {
      get() {
        return this.content;
      },
      set(value) {
        return this.$emit('update:content', value);
      },
    },
  },
};
</script>
